import { Box, ColorOptions, Icon, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import React, { FC, useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { FlatList } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
import { EmType } from '../../screens/EntityManagement'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { SearchListItem } from './SearchListItem'
import { styles } from './styles'

const searchDurationLabel = ''
const searchLabel = 'Search Entity'
const labelRecents = 'RECENT SEARCHES'
const searchFiltersData = [
  { id: '1', value: 'Group ID' },
  { id: '2', value: 'SubGroup ID' },
  { id: '3', value: 'Entity ID' },
  { id: '4', value: 'Entity Name' },
  { id: '5', value: 'Mobile Number' },
  { id: '6', value: 'Device Serial No.' },
  { id: '7', value: 'VPA' },
  { id: '8', value: 'TID' },
  { id: '9', value: 'Email Id' },
  { id: '10', value: 'Pincode' },
  { id: '11', value: 'Store Code' },
]

const getSearchLabel = (filterSelected: string): string => {
  const mapLabel: any = {
    'Group ID': `${searchLabel} by Group ID...`,
    'SubGroup ID': `${searchLabel} by SubGroup ID...`,
    'Entity ID': `${searchLabel} by Entity ID...`,
    'Entity Name': `${searchLabel} by Entity Name...`,
    'Mobile Number': `${searchLabel} by Mobile Number...`,
    'Device Serial No.': `${searchLabel} by Device Serial No...`,
    VPA: `${searchLabel} by VPA...`,
    TID: `${searchLabel} by TID...`,
    'Email Id': `${searchLabel} by Email Id...`,
    Pincode: `${searchLabel} by Pincode...`,
  }
  return mapLabel[filterSelected]
}

const getSearchFilterKey: any = {
  'Group ID': 'groupId',
  'SubGroup ID': 'subGroupId',
  'Entity ID': 'entityId',
  'Entity Name': 'legalName',
  'Mobile Number': 'mobileNumber',
  'Device Serial No.': 'deviceSerialNo',
  VPA: 'midVpa',
  TID: 'tid',
  'Email Id': 'emailId',
  Pincode: 'pinCode',
}

const defaultValidatorForMinimumEntry = 3
export enum SearchBarTypes {
  DEFAULT = 'Default',
}
export interface SearchBarProps {
  type: SearchBarTypes
  navigation: any
  // searchData: any[]
  recentData: string[]
  onChange?: (globalSearchString: string) => void
  onResultClicked: (show: boolean, txnId: string, filterKey: string) => void
}
export interface PortalProps {
  isListVisible: boolean
  noDataVisible: boolean
  data: Array<any>
  isRecents: boolean
  width: number
  setValue: (value: string) => void
  setListVisible: (value: boolean) => void
  setNoDataVisible: (value: boolean) => void
  handleItemPress: (item: any) => void
  screenWidth: number
}

const RenderPortal = ({
  isListVisible,
  noDataVisible,
  data,
  isRecents,
  width,
  setValue,
  setListVisible,
  setNoDataVisible,
  handleItemPress,
  screenWidth,
}: PortalProps): React.ReactElement => {
  if (!isRecents || data?.length === 0) {
    return <></>
  }
  const handleClose = (): void => {
    setValue('')
    setListVisible(false)
    setNoDataVisible(false)
  }

  const keyExtractor = (itemData: any): string => {
    return itemData.id
  }

  const getSeperator = () => <Box height={1} borderColor={'GREY_SEPARATOR'} borderWidth={1} />

  const renderItem = (itemData: any) => (
    <SearchListItem data={itemData} onPress={handleItemPress} isRecents={isRecents} />
  )
  const getView = (): React.ReactElement => {
    if (isListVisible || noDataVisible) {
      return (
        <Box underlayColor={'TRANSPARENT'} onPress={handleClose} {...styles(screenWidth).dropdown}>
          <Box {...styles(screenWidth).list} w={width} borderTopColor={'BLUE'} borderTopWidth={1}>
            <Box pv={12} ph={16}>
              <Text hide={!isRecents} {...styles(screenWidth).recentsTextStyle}>
                {labelRecents}
              </Text>
            </Box>
            {getSeperator()}
            <ModBox show={isListVisible} pl={16}>
              <FlatList
                testID={'searchResultList'}
                data={data ?? []}
                renderItem={renderItem}
                keyExtractor={keyExtractor}
                ItemSeparatorComponent={getSeperator}
              />
            </ModBox>
          </Box>
        </Box>
      )
    }
    return <></>
  }
  return ReactDOM.createPortal(getView(), document.body)
}

const GlobalSearchBar: FC<SearchBarProps> = ({ onResultClicked, recentData, navigation }: SearchBarProps) => {
  const {
    searchData,
    fetchSearchEntity,
    globalSearchString,
    updateGlobalSearchString,
    searchFilterBy,
    setSearchFilterBy,
    updateRecents,
    setSearchApiStatus,
    getGroupsList,
    getSubGroupsList,
    searchApiStatus,
    resetPagination,
  } = useStores((store) => ({
    searchData: store.getSearchData(EmType.Search),
    fetchSearchEntity: store.fetchSearchEntity,
    globalSearchString: store.onboarding.globalSearchString,
    updateGlobalSearchString: store.onboarding.updateGlobalSearchString,
    searchFilterBy: store.onboarding.searchFilterBy,
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    updateRecents: store.updateSearchRecents,
    setSearchApiStatus: store.onboarding.setSearchApiStatus,
    getGroupsList: store.getGroupsList,
    getSubGroupsList: store.getSubGroupsList,
    searchApiStatus: store.onboarding.searchApiStatus,
    resetPagination: store?.resetPagination,
  }))

  const [value, setValue] = useState('')
  const [isListVisible, setListVisible] = useState(false)
  const [noDataVisible, setNoDataVisible] = useState(false)
  const [data, setData] = useState([] as Array<any>)
  const [isRecents, setShowRecents] = useState(false)
  const [width, setWidth] = useState(0)
  const [searchResultVisibility, setSearchResultVisibility] = useState(false)
  const [searchApi, searchHandler] = useLazyApiData(fetchSearchEntity)
  const [searchGroupApi, searchGroupApiHandler] = useLazyApiData(getGroupsList)
  const [searchSubGroupApi, searchSubGroupApiHandler] = useLazyApiData(getSubGroupsList)

  // const setTxnDetailsVisibility = useCallback(
  //   (itemValue, txnId, filterItem) => onResultClicked(itemValue, txnId, filterItem),
  //   [onResultClicked],
  // )

  const { navigate } = navigation
  useEffect(() => {
    setValue(globalSearchString)
  }, [globalSearchString])

  useEffect(() => {
    if (searchHandler.state === 'fulfilled') {
      console.log('searchHandler data', searchHandler.data)
      if (searchHandler.data && searchHandler.data instanceof Object) {
        setSearchResultVisibility(true)
        updateGlobalSearchString(value)
        navigation.reset({
          index: 0,
          routes: [{ name: 'searchEntity' }],
        })
        setSearchApiStatus('fulfilled')
      }
    } else if (searchHandler.state === 'rejected') {
      setSearchApiStatus('rejected')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchHandler.state])

  useEffect(() => {
    if (searchGroupApiHandler.state === 'fulfilled') {
      if (searchGroupApiHandler.data && searchGroupApiHandler.data instanceof Object) {
        setSearchResultVisibility(true)
        updateGlobalSearchString(value)
        navigation.reset({
          index: 0,
          routes: [{ name: 'searchEntity' }],
        })
        setSearchApiStatus('fulfilled')
      }
    } else if (searchGroupApiHandler.state === 'rejected') {
      setSearchApiStatus('rejected')
    }
  }, [
    searchGroupApiHandler.state,
    searchGroupApiHandler.data,
    updateGlobalSearchString,
    value,
    navigation,
    setSearchApiStatus,
  ])

  useEffect(() => {
    if (searchSubGroupApiHandler.state === 'fulfilled') {
      if (searchSubGroupApiHandler.data && searchSubGroupApiHandler.data instanceof Object) {
        setSearchResultVisibility(true)
        updateGlobalSearchString(value)
        navigation.reset({
          index: 0,
          routes: [{ name: 'searchEntity' }],
        })
        setSearchApiStatus('fulfilled')
      }
    } else if (searchSubGroupApiHandler.state === 'rejected') {
      setSearchApiStatus('rejected')
    }
  }, [
    navigation,
    searchSubGroupApiHandler.data,
    searchSubGroupApiHandler.state,
    setSearchApiStatus,
    updateGlobalSearchString,
    value,
  ])

  const onSearchStringChanged = (text: string): void => {
    setValue(text)
    setShowRecents(false)
  }

  const handleSearchClick = useCallback(() => {
    resetPagination()
    if (value?.length > 0) {
      // updateFieldSettings(getSearchFilterKey[searchFilterBy])
      updateGlobalSearchString(value?.trim())
      if (searchFilterBy === 'Group ID') {
        searchGroupApi(value?.trim(), searchFilterBy)
      } else if (searchFilterBy === 'SubGroup ID') {
        searchSubGroupApi('', value?.trim())
      } else {
        searchApi(value?.trim(), searchFilterBy, 'ALL')
      }
      setSearchApiStatus('pending')
      updateRecents(value?.trim(), searchFilterBy)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchApi, updateRecents, value])

  const handleItemPress = (itemData: any): void => {
    resetPagination()
    setValue(itemData?.item?.searchString)
    setListVisible(false)
    handleKeyChange(itemData?.item?.filterKey)
    if (searchFilterBy === 'Group ID') {
      searchGroupApi(itemData?.item?.searchString, searchFilterBy)
    } else if (searchFilterBy === 'SubGroup ID') {
      searchSubGroupApi('', itemData?.item?.searchString)
    } else {
      searchApi(itemData?.item?.searchString, itemData?.item?.filterKey)
    }
  }
  const handleClose = (): void => {
    setValue('')
    setListVisible(false)
    setNoDataVisible(false)
    setSearchResultVisibility(false)
    updateGlobalSearchString('')
    // navigate('home')
  }

  const getRecentsListData = (recents: any): void => {
    const recentsParsedData: any[] = []
    recents.map((recentItem: any) => {
      const newData = searchData?.filter((searchItem: any) => recentItem.id === searchItem?.id)[0]
      newData &&
        recentsParsedData.push({ key: recentItem.filterKey, value: newData[getSearchFilterKey[recentItem.filterKey]] })
      return newData
    })
    setData(recents.slice(0, 5))
    setListVisible(recents.length > 0)
    setNoDataVisible(recents.length === 0)
  }
  const handleFocus = (): void => {
    setShowRecents(recentData.length > 0 && value?.length === 0)
    recentData.length > 0 && getRecentsListData(recentData)
  }

  const handleOnChange = (text: string): void => {
    onSearchStringChanged(text)
  }

  const handleKeyChange = useCallback(
    (item: any) => {
      setSearchFilterBy(item)
      if (searchFilterBy !== item) {
        setValue('')
      }
      setListVisible(false)
      setNoDataVisible(false)
      setSearchResultVisibility(false)
      updateGlobalSearchString('')
      // navigation.reset({
      //   index: 0,
      //   routes: [{ name: 'home' }],
      // })
      /**
       * Value must not be empty and it must be more than atleast minimum required to save API calls hit
       * if the input param is way to less.
       */
      // value?.length > defaultValidatorForMinimumEntry && handleSearchClick()
    },
    [searchFilterBy, setSearchFilterBy, updateGlobalSearchString],
  )

  // const searchResult = searchData?.length > 1 ? searchData?.slice(1) : []
  return (
    <>
      <RenderPortal
        isListVisible={isListVisible}
        noDataVisible={noDataVisible}
        data={data}
        isRecents={isRecents}
        width={480}
        setValue={setValue}
        setListVisible={setShowRecents}
        setNoDataVisible={setNoDataVisible}
        handleItemPress={handleItemPress}
        screenWidth={480}
      />
      <Box
        minWidth={480}
        direction={'row'}
        align={'center'}
        pl={8}
        justify="space-between"
        borderWidth={1}
        borderColor={'#F0F0F0' as ColorOptions}
        borderRadius={4}
        onLayout={(event) => setWidth(event.nativeEvent.layout.width)}>
        <Box direction="row" align={'center'}>
          <DropdownOptimised
            placeHolder={searchFilterBy ?? searchFiltersData?.[0]?.value}
            type={DropdownTypes.DEFAULT_WITH_BG}
            data={searchFiltersData}
            onChange={handleKeyChange}
          />
          <Spacer direction="horizontal" size={12} />
          <Box width={'90%'}>
            <TextInput
              value={value}
              type="body1"
              fontWeight="500"
              onFocusBottomLineColor="TRANSPARENT"
              bottomLineColor="TRANSPARENT"
              placeholder={getSearchLabel(searchFilterBy)}
              placeholderTextColor="LIGHT_BLACK"
              onFocus={handleFocus}
              onChangeText={handleOnChange}
              editable={searchHandler?.state !== 'pending' || searchGroupApiHandler?.state !== 'pending'}
            />
          </Box>
        </Box>
        <ModBox pointerEvents="none" {...styles(width).searchDurationViewStyle}>
          <Text hide={isListVisible || value?.trim()?.length > 0} type={'caption'} color={'PRIMARY_GREY'}>
            {searchDurationLabel}
          </Text>
          <ModBox
            show={
              searchHandler?.state === 'pending' ||
              searchGroupApiHandler?.state === 'pending' ||
              searchSubGroupApiHandler?.state === 'pending'
            }
            flexDirection={'row'}>
            <Loader color={'PRIMARY'} type={16} />
            <Spacer direction={'horizontal'} size={8} />
            <Text type={'caption'} color={'PRIMARY_GREY'}>
              {'searching'}
            </Text>
          </ModBox>
          <ModBox
            show={
              globalSearchString.length > 0 &&
              searchData?.length === 0 &&
              searchHandler?.state !== 'pending' &&
              searchGroupApiHandler?.state !== 'pending' &&
              searchSubGroupApiHandler?.state !== 'pending' &&
              searchApiStatus === 'rejected'
            }>
            <Text type={'caption'} color={'PRIMARY_GREY'}>
              {'Oops!..No results found'}
            </Text>
          </ModBox>
        </ModBox>
        <Spacer direction="horizontal" size={12} />
        <Box
          {...styles(width).searchIconContainer}
          onPress={
            searchHandler?.state === 'pending' || globalSearchString === value ? handleClose : handleSearchClick
          }>
          <Icon
            id={'SEARCH'}
            color={'BLUE'}
            size={16}
            hide={(searchHandler?.state === 'pending' || globalSearchString === value) && globalSearchString !== ''}
          />
          <Icon
            hide={!(searchHandler?.state === 'pending' || globalSearchString === value) || globalSearchString === ''}
            id={'CLOSE'}
            color={'BLUE'}
            size={16}
          />
        </Box>
      </Box>
    </>
  )
}

export default GlobalSearchBar
